import React from 'react'
import './SideDrawer.css'
import pic1 from '../image/pic1.jpeg'
import {HashRouter, Link} from 'react-router-dom';

const sideDrawer = props => {
  let drawerClasses = 'side-drawer';
  if (props.show) {
    drawerClasses = 'side-drawer open';
  }
  return (
    <HashRouter>
    <nav className={drawerClasses}>
      <div className="slide_contain">
      <img class="img1" src={pic1} width="100" height="150"/>
      </div>
      <ul>
      <li>
          <Link className="link" to="/">Home</Link>
          </li>
          <li>
          <Link className="link" to="/About">About Us</Link>
          </li>
		        <li>
            <a href="/Pages">Pages</a>
          </li>
		        <li>
            <Link className="link" to="/Blogs">Blogs</Link>
          </li>
        <li>
        <Link className="link" to="/Contact">Contact</Link>
        </li>
        {/*<a class="donate_button"href="/">Donation!</a>*/}
      </ul>
    </nav>
    </HashRouter>
  );
};

export default sideDrawer;



